import React from "react";
import { delay, motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import {
  containerVariants,
  itemVariants,
  photoVariants,
} from "../../variants/variants";

const Section6 = () => {
  const { t } = useTranslation();
  
  return (
    <div className="mt-28">
      <motion.div
        initial="hidden"
        whileInView="visible"
        exit="exit"
        variants={containerVariants}
        className="  grid grid-cols-1 md:grid-cols-2 "
      >
        <div className="  overflow-hidden ">
          <motion.img
            initial="initial"
            whileInView="whileInView"
            exit="exit"
            variants={photoVariants}
            src="/images/sustainability/solar.jpg"
            className="h-full w-full object-cover "
          />
        </div>

        <div className="space-y-5  py-14 px-[10%]  md:pl-14 md:pr-[20%] flex flex-col justify-center    ">
          <motion.h2 variants={itemVariants} className="text-75">
            {t("sustainability.solarEnergy.title")}
            <br />
            <span className="font-light">{t("sustainability.solarEnergy.subtitle")}</span>
          </motion.h2>

          <motion.p
            variants={itemVariants}
            className="text-20 font-medium text-customGray5"
          >
            {t("sustainability.solarEnergy.description")}
          </motion.p>
        </div>
      </motion.div>

      <motion.div
        initial="hidden"
        whileInView="visible"
        exit="exit"
        variants={containerVariants}
        className=" grid grid-cols-1 md:grid-cols-2 "
      >
        <div className="space-y-5 py-14 md:pr-14  px-[10%] md:pb-14 md:pl-[20%] flex flex-col justify-center ">
          <motion.h2 variants={itemVariants} className="text-75">
            {t("sustainability.chemical.title")}
            <br />
            <span className="font-light">{t("sustainability.chemical.subtitle")}</span>
          </motion.h2>

          <motion.p
            variants={itemVariants}
            className="text-20 font-medium text-customGray5"
            dangerouslySetInnerHTML={{ __html: t("sustainability.chemical.text1") }}
          />
          <motion.p
            variants={itemVariants}
            className="text-20 font-medium text-customGray5"
          >
            {t("sustainability.chemical.text2")}
          </motion.p>
        </div>

        <div  className="-order-1 md:order-none overflow-hidden">
          <motion.img
            initial="initial"
            whileInView="whileInView"
            exit="exit"
            variants={photoVariants}
            src="/images/sustainability/colorful.jpg"
            className="h-full w-full object-cover "
          />
        </div>
      </motion.div>

      <motion.div
        initial="hidden"
        whileInView="visible"
        exit="exit"
        variants={containerVariants}
        className="  grid grid-cols-1 md:grid-cols-2"
      >
        <div className="overflow-hidden">
          <motion.img

initial="initial"
whileInView="whileInView"
exit="exit"
variants={photoVariants}
            src="/images/sustainability/menderes.jpg"
            className="h-full w-full object-cover"
          />
        </div>

        <div className="space-y-5  py-14 px-[10%]  md:pl-14 md:pr-[20%] flex flex-col justify-center   ">
          <motion.h2 variants={itemVariants} className="text-75">
            {t("sustainability.menderes.title")}
            <br />
            <span className="font-light">{t("sustainability.menderes.subtitle")}</span>
          </motion.h2>

          <motion.p
            variants={itemVariants}
            className="text-20 font-medium text-customGray5"
          >
            {t("sustainability.menderes.description")}
          </motion.p>
        </div>
      </motion.div>

      <motion.div
              initial="hidden"
              whileInView="visible"
              exit="exit"
              variants={containerVariants}
      className=" grid grid-cols-1 md:grid-cols-2 ">
        <div className="space-y-5 py-14 md:pr-14  px-[10%] md:pb-14 md:pl-[20%] flex flex-col justify-center ">
          <motion.h2 variants={itemVariants} className="text-75">
            {t("sustainability.waste.title")}
            <br />
            <span className="font-light">{t("sustainability.waste.subtitle")}</span>
          </motion.h2>

          <motion.p variants={itemVariants} className="text-20 font-medium text-customGray5">
            {t("sustainability.waste.description")}
          </motion.p>
        </div>

        <div  className="-order-1 md:order-none overflow-hidden">
          <motion.img
          initial="initial"
          whileInView="whileInView"
          exit="exit"
          variants={photoVariants}
            src="/images/sustainability/zero.jpg"
            className="h-full w-full object-cover"
          />
        </div>
      </motion.div>
    </div>
  );
};

export default Section6;
